export default __webpack_public_path__ + "static/media/gallery_01.6bb00de9.jpg";